import { useMockMode } from '@src/modules/react_hooks/useMockMode';
import type React from 'react';
import { createContext, type ReactNode, useContext } from 'react';

/**
 * モックモードコンテキストの型定義
 */
interface MockModeContextType {
  isMockMode: boolean;
  apiConfig: ReturnType<typeof import('@src/config/api').getApiConfig>;
  toggleMockMode: () => void;
  setMockMode: (mockMode: boolean) => void;
  resetToNormalMode: () => void;
}

/**
 * モックモードコンテキスト
 */
const MockModeContext = createContext<MockModeContextType | undefined>(undefined);

/**
 * モックモードコンテキストを使用するフック
 */
export function useMockModeContext(): MockModeContextType {
  const context = useContext(MockModeContext);
  if (context === undefined) {
    throw new Error('useMockModeContext must be used within a MockModeProvider');
  }
  return context;
}

/**
 * モックモードプロバイダーのプロパティ
 */
interface MockModeProviderProps {
  children: ReactNode;
}

/**
 * モックモードプロバイダー
 * アプリケーション全体でモックモードの状態を管理
 */
export function MockModeProvider({ children }: MockModeProviderProps): React.ReactElement {
  const mockModeState = useMockMode();

  return <MockModeContext.Provider value={mockModeState}>{children}</MockModeContext.Provider>;
}
